import React from "react";
import cx from "classnames";
import { Image } from "src/components/image";
import { Link } from "src/components/link";
import { BlockContent } from "src/components/block-content";
import { ShadowBorder } from "src/components/shadow-border";

import { ArrowLeft, ArrowRight, Dots } from "src/components/slider-ui";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

import * as styles from "./partnership-carousel.module.css";

const Slide = ({ data, active }: { data: any; active: boolean }) => {
	const { copy, image, link, partnerLogo } = data;
	return (
		<div className={cx("keen-slider__slide", styles.slide)}>
			<ShadowBorder className={styles.slideOuter}>
				<div className={styles.slideInner}>
					<div className={styles.slideImageColumn}>
						{partnerLogo?.asset && (
							<Image
								asset={partnerLogo.asset}
								alt={partnerLogo.alt}
								className={styles.slideLogo}
							/>
						)}
						{image?.asset && (
							<Image
								asset={image.asset}
								alt={image.alt}
								className={cx("hide-max-medium", styles.slideImage)}
							/>
						)}
					</div>
					<div className={styles.slideCopyColumn}>
						<BlockContent blocks={copy} className="small-body" />
						{link && (
							<Link
								className={styles.slideLink}
								link={link}
								type={link.linkType}
							>
								<span className="label underline-on-hover">
									{link.linkCopy}
								</span>
							</Link>
						)}
					</div>
				</div>
			</ShadowBorder>
		</div>
	);
};

export const PartnershipCarousel = ({
	data,
}: {
	data: { partners: any[] };
}) => {
	const { partners } = data;

	const [currentSlide, setCurrentSlide] = React.useState(0);

	const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
		slidesPerView: 1.1,
		mode: "snap",
		spacing: 0,
		centered: true,
		loop: true,
		initial: 0,
		slideChanged(s) {
			setCurrentSlide(s.details().relativeSlide);
		},
		breakpoints: {
			"(min-width: 1024px)": {
				slidesPerView: 1.5,
			},
			"(min-width: 1366px)": {
				slidesPerView: 2,
			},
		},
	});

	return (
		<div className={styles.partnershipCarousel}>
			<div ref={sliderRef} className={cx("keen-slider", styles.slider)}>
				{partners.map((partner: any, index: number) => (
					<Slide data={partner} active={currentSlide === index} key={index} />
				))}
			</div>
			{slider && (
				<>
					<ArrowLeft onClick={(e) => e.stopPropagation() || slider.prev()} />
					<ArrowRight onClick={(e) => e.stopPropagation() || slider.next()} />
				</>
			)}
			{slider && <Dots slider={slider} currentSlide={currentSlide} />}
		</div>
	);
};
